module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_5010.b335aff8.png";